import React from 'react';
import { X } from 'lucide-react';

interface NotificationBannerProps {
  message: string;
  type?: 'info' | 'error' | 'warning' | 'success';
  onDismiss?: () => void;
  autoHideMs?: number;
  className?: string;
}

const typeClasses: Record<'info' | 'error' | 'warning' | 'success', string> = {
  info: 'bg-blue-600 text-white',
  error: 'bg-red-600 text-white',
  warning: 'bg-amber-500 text-black',
  success: 'bg-green-600 text-white',
};

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
  message,
  type = 'info',
  onDismiss,
  autoHideMs = 6000,
  className,
}) => {
  React.useEffect(() => {
    if (autoHideMs > 0) {
      const t = setTimeout(() => onDismiss?.(), autoHideMs);
      return () => clearTimeout(t);
    }
  }, [autoHideMs, onDismiss]);

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 py-2 shadow-md ${typeClasses[type]} transition ${className ?? ''}`}
    >
      <span className="text-sm font-medium">{message}</span>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss notification"
          className="ml-4 inline-flex rounded p-1 hover:bg-white/10 focus:outline-none"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
